const locale = {
    placeholder: 'Уақытты таңдаңыз',
    rangePlaceholder: ['Бастау уақыты', 'Аяқталу уақыты'],
};
export default locale;
